/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './not-found-page.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/shared/not-found/not-found-page.component';
const styles_NotFoundPageComponent:any[] = [i0.styles];
export const RenderType_NotFoundPageComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_NotFoundPageComponent,data:{}});
export function View_NotFoundPageComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h1',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['404 Page Not Found']))],(null as any),(null as any));
}
export function View_NotFoundPageComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'not-found-page',
      ([] as any[]),(null as any),(null as any),(null as any),View_NotFoundPageComponent_0,
      RenderType_NotFoundPageComponent)),i1.ɵdid(49152,(null as any),0,i2.NotFoundPageComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const NotFoundPageComponentNgFactory:i1.ComponentFactory<i2.NotFoundPageComponent> = i1.ɵccf('not-found-page',
    i2.NotFoundPageComponent,View_NotFoundPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL25vdC1mb3VuZC9ub3QtZm91bmQtcGFnZS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2UvYXBwcy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvbm90LWZvdW5kL25vdC1mb3VuZC1wYWdlLmNvbXBvbmVudC50cyIsIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL25vdC1mb3VuZC9ub3QtZm91bmQtcGFnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL25vdC1mb3VuZC9ub3QtZm91bmQtcGFnZS5jb21wb25lbnQudHMuTm90Rm91bmRQYWdlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGgxPjQwNCBQYWdlIE5vdCBGb3VuZDwvaDE+IiwiPG5vdC1mb3VuZC1wYWdlPjwvbm90LWZvdW5kLXBhZ2U+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUEsd0VBQUk7YUFBQTs7O29CQ0FKO01BQUE7c0NBQUEsVUFBQTtNQUFBOzs7In0=



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/shared/not-found/not-found-page.component.ngfactory.ts